import gameObjectTypes from './gameObjectTypes';

export default [
    gameObjectTypes.DIVIDE_LINE,
    gameObjectTypes.CURBSTONE_SEPARATOR_LEFT,
    gameObjectTypes.CURBSTONE_SEPARATOR_RIGHT,
    gameObjectTypes.HUMMOCK_1_LEFT,
    gameObjectTypes.HUMMOCK_1_RIGHT,
    gameObjectTypes.BUSH_1_LEFT,
    gameObjectTypes.BUSH_1_RIGHT,
    gameObjectTypes.BUSH_2_LEFT,
    gameObjectTypes.BUSH_2_RIGHT,
    gameObjectTypes.BUSH_3_LEFT,
    gameObjectTypes.BUSH_3_RIGHT,
    gameObjectTypes.SIGN_60_LEFT,
    gameObjectTypes.SIGN_60_RIGHT,
    gameObjectTypes.SIGN_MOOSE_LEFT,
    gameObjectTypes.SIGN_MOOSE_RIGHT,
    gameObjectTypes.TREE_2_LEFT,
    gameObjectTypes.TREE_2_RIGHT,
    gameObjectTypes.TREE_3_LEFT,
    gameObjectTypes.TREE_3_RIGHT,
    gameObjectTypes.TREE_4_LEFT,
    gameObjectTypes.TREE_4_RIGHT,
    gameObjectTypes.TREE_1_LEFT,
    gameObjectTypes.TREE_1_RIGHT,
    gameObjectTypes.ROCK_1_LEFT,
    gameObjectTypes.ROCK_1_RIGHT,
    gameObjectTypes.ROCK_2_LEFT,
    gameObjectTypes.ROCK_2_RIGHT,
    gameObjectTypes.ANIMAL_1_RIGHT,
    gameObjectTypes.ANIMAL_2_RIGHT,
    gameObjectTypes.REGION_LAKE,
    gameObjectTypes.REGION_1_SIGN,
    gameObjectTypes.REGION_1_BUILDING,
    gameObjectTypes.REGION_2_SIGN,
    gameObjectTypes.REGION_3_SIGN,
    gameObjectTypes.REGION_3_BUILDING,
    gameObjectTypes.REGION_5_SIGN,
    gameObjectTypes.REGION_7_BUILDING,
    gameObjectTypes.REGION_7_SIGN,
    gameObjectTypes.REGION_8_SIGN,
    gameObjectTypes.SKIS_IN_SNOWDRIFT,
    gameObjectTypes.SLED_IN_SNOWDRIFT,
    gameObjectTypes.STUMP_LEFT,
    gameObjectTypes.STUMP_RIGHT
];
